export default __webpack_public_path__ + "420ab763c0474bb8bb2954942aab1aac.png";